import { useMediaQuery } from "./useMediaQuery";

/**
 * A hook that returns whether the user prefers reduced motion and updates when the user changes their preference.
 * @returns `true` if user prefers reduced motion and `false` if they do not have a preference set.
 */
export function usePrefersReducedMotion() {
    return useMediaQuery('(prefers-reduced-motion: reduce)');
}

/**
 * A hook that returns whether the user prefers reduced transparency and updates when the user changes their preference.
 * @returns `true` if user prefers reduced transparency and `false` if they do not have a preference set.
 */
export function usePrefersReducedTransparency() {
    return useMediaQuery('(prefers-reduced-transparency: reduce)');
}

/**
 * A hook that returns whether the user prefers increased contrast and updates when the user changes their preference.
 * @returns `true` if user prefers increased contrast and `false` if they do not have a preference set.
 */
export function usePrefersIncreasedContrast() {
    return useMediaQuery('(prefers-contrast: more)');
}

/**
 * A hook that returns whether the user prefers decreased contrast and updates when the user changes their preference.
 * @returns `true` if user prefers decreased contrast and `false` if they do not
 */
export function usePrefersDecreasedContrast() {
    return useMediaQuery('(prefers-contrast: less)');
}
